<template>
    <div class="form-group">
        <label>{{ name }}</label>
        <div :class="field.type" v-for="box in boxes" :key="box.id">
            <label :for="box.id">
                <input
                    :id="box.id"
                    type="radio"
                    v-if="field.type === 'radio'"
                    :name="name"
                    :value="box.value"
                >
                <CheckBox v-else
                    :fieldId="fieldId"
                    :labelId="box.id"
                /> {{ box.value }}
            </label>
        </div>
    </div>
</template>

<script>
    import CheckBox from './CheckBox.vue';

    export default {
        name: 'Radio',
        props: [
            'fieldId',
        ],
        components: {
            CheckBox,
        },
        computed: {
            field() {
                const { state } = this.$store

                return state.fields[this.fieldId]
            },
            name() {
                return this.field.labels[this.field.labelsOrder[0]]
            },
            boxes() {
                return this.field.labelsOrder.slice(1).map((boxId) => ({
                    id: boxId,
                    value: this.field.labels[boxId],
                }))
            },
            checked(boxId) {
                console.log(this);
                return false;
            },
        },
        methods: {
            setChecked(e) {
                const labelId = e.target.id;
                const checked = e.target.checked;

                this.$store.commit('setChecked', { labelId, checked })
            },
        },
    }
</script>

<style lang="scss" scoped>
    .fb-box {
        margin-left: 0 !important;
    }
</style>
